import React from "react";
import styled from "styled-components";
import { colors } from "../theme/colors";

const NoDataState = ({
  icon = "📋",
  title = "No Data Available",
  message = "There's nothing to show here yet.",
  className,
  ...props
}) => {
  return (
    <NoDataContainer className={className} {...props}>
      <NoDataIcon>{icon}</NoDataIcon>
      <NoDataTitle>{title}</NoDataTitle>
      <NoDataMessage>{message}</NoDataMessage>
    </NoDataContainer>
  );
};

const NoDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.05) 0%,
    rgba(255, 255, 255, 0.02) 100%
  );
  border: 1px dashed ${colors.neutral[300]};
  border-radius: 12px;
  margin: 16px 0;
`;

const NoDataIcon = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.6;
`;

const NoDataTitle = styled.h4`
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: ${colors.neutral[700]};
`;

const NoDataMessage = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${colors.neutral[500]};
  line-height: 1.6;
  max-width: 400px;
`;

export default NoDataState;
